import { VbzButton, VbzModal } from '@smiles/voebiz-ui-kit';
import React, { FC } from 'react';
import { ModalBody } from 'reactstrap';
import { error } from '../../assets';

interface ModalErrorProps {
  isOpenModalError: boolean;
  toggleModalError: () => void;
}

const ModalError: FC<ModalErrorProps> = ({ isOpenModalError, toggleModalError }) => {
  return (
    <>
      <VbzModal isOpen={isOpenModalError} type="right" desktopSize="small" toggle={toggleModalError}>
        <ModalBody>
          <div className="modal-error__image">
            <img src={error} alt="mala quebrada" />
          </div>
          <div className="modal-error__title">
            <h3>Desculpe, a operação falhou...</h3>
          </div>

          <div className="modal-error__description">
            <p>Vamos tentar de novo?</p>
            <div className="error-modal-btn">
              <VbzButton
                id="error-modal-btn"
                className="error-modal-button"
                color="primary"
                text="Tentar novamente"
                onClick={toggleModalError}
              />
            </div>
          </div>
        </ModalBody>
      </VbzModal>
    </>
  );
};
export default ModalError;
